/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {SMSBalance, SMSMessage, SMSPredefined} from '../models/sms.model';
import {API_ENDPOINTS} from '../api/api-endpoints';


@Injectable({providedIn: 'root'})
export class TwilioService {

	getTwilioAccountBalance(): Observable<string> {
		return this.http.post(
			API_ENDPOINTS.TWILIO.GET_ACCOUNT_BALANCE,
			{}
		)
			.pipe(
				// map((response: ServerResponse) => {
				map((response: any) => {
					if (!response.error) {
						return response.message;
					} else {
						return 'N/A';
					}
				})
			);
	}


	constructor(private http: HttpClient) { }

}
